import { r as registerInstance, h, g as getElement } from './index-d4808923.js';
import { c as classesToString } from './utils-17533423.js';

const gravityCounterBadgeCss = ":host{display:inline-block}.counter-badge{border-radius:9999px;box-shadow:inset transparent 0 0 0 1px;box-sizing:border-box;display:block;min-width:16px;padding:0 4px;text-align:center}.counter-badge__text{display:block}.counter-badge--primary{background-color:#1B6AEE}.counter-badge--secondary{background-color:#F8F8F8;box-shadow:inset rgba(0, 15, 30, 0.05) 0 0 0 1px}.counter-badge--warning{background-color:#FF9000}.counter-badge--danger{background-color:#DB0A40}.counter-badge--light{background-color:#F8F8F8}.counter-badge--success{background-color:#159D48}";
const GravityCounterBadgeStyle0 = gravityCounterBadgeCss;

const GravityCounterBadge = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.type = 'primary';
    }
    getTextColor() {
        if (this.type == 'secondary' || this.type == 'light' || this.type == 'warning') {
            return 'dark';
        }
        else {
            return 'light';
        }
    }
    render() {
        const classes = [`counter-badge`, `counter-badge--${this.type}`];
        return (h("span", { key: '003b2c158ee744fe983efcdd09e11be3e1da7068', class: classesToString(classes) }, h("gravity-text", { key: 'bbd97ebde0fb9fef457298438d32046757776889', class: "counter-badge__text", color: this.getTextColor(), size: "xx-small", weight: "medium" }, h("slot", { key: '990cb2bad1460e0163ea193787636f8683bf3786' }))));
    }
    get element() { return getElement(this); }
};
GravityCounterBadge.style = GravityCounterBadgeStyle0;

export { GravityCounterBadge as gravity_counter_badge };

//# sourceMappingURL=gravity-counter-badge.entry.js.map